<template>
<Nav />
<Content>
  <Sounds />
</Content>
<Footer />
</template>

<script>
import Nav from '@/components/Nav.vue'
import Content from '@/components/Content.vue'
import Sounds from '@/components/sounds/Sounds.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'SoundsView',
    components: {Nav, Footer, Content, Sounds},
}
</script>
